import { CurrencyISO } from '@guiker/money'
import { yup } from '@guiker/yup-util'

export const topupSchema = yup.object({
  amount: yup.number(),
  currency: yup.string().oneOf(Object.values(CurrencyISO)),
})
